import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';


import Wallbox from './Wallbox/Wallbox';
import WallboxSingle from './Wallbox/WallboxSingle';
import ChargeEvents from './ChargeEvents/ChargeEvents';
import User from './User/User';
import UserSingle from './User/UserSingle';
import Roles from './User/Roles';
import Permissions from './User/Permissions';

import Login from './Login/Login';


import './App.scss';
/* import Register from './Register/Register'; */
import AuthProvider from '../context/AuthProvider';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../Routes/PrivateRoute';

const App = () => {

  return (
    <>
      <AuthProvider>
        <Router>
          <Switch>
            <PrivateRoute exact path='/'>
              <Wallbox />
            </PrivateRoute>

            <PrivateRoute exact path='/wallbox/:wallboxId'>
              <WallboxSingle />
            </PrivateRoute>

            <PrivateRoute exact path='/chargeEvents'>
              <ChargeEvents />
            </PrivateRoute>

            <PrivateRoute exact path='/users'>
              <User />
            </PrivateRoute>

            <PrivateRoute exact path='/user_single'>
              <UserSingle />
            </PrivateRoute>

            <PrivateRoute exact path='/roles'>
              <Roles />
            </PrivateRoute>

            <PrivateRoute exact path='/permissions'>
              <Permissions />
            </PrivateRoute>
            <Route exact path='/login' component={Login} />
            {/*  <Route exact path='/register' component={Register} /> */}
          </Switch>
        </Router>
      </AuthProvider>


    </>
  )
}

export default App
